import { render } from "./Sustentabilidad.vue?vue&type=template&id=b115f3ee&scoped=true"
import script from "./Sustentabilidad.vue?vue&type=script&lang=js"
export * from "./Sustentabilidad.vue?vue&type=script&lang=js"

import "./Sustentabilidad.vue?vue&type=style&index=0&id=b115f3ee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b115f3ee"]])

export default __exports__